export const sqmToHa = (value: unknown) => {
  if (value === undefined) {
    return ''
  } else {
    return (Number(value) / 10000).toFixed(2)
  }
}
